/** @module csi/widget/_svg/Save */
define([
	"dijit/form/Button",
	"./_Plugin",
	"./PluginFactory"
], function(Button, _Plugin, PluginFactory) {

	return PluginFactory.declare([Button, _Plugin], {
		materialIcon: "save",
		pluginName: "save",
		title: "CanvasSaveAndContinue",

		/**
		 * @override
		 * Disable plugin if cannot edit the canvas - it's possible the state changes once in edit mode
		 */
		enablePlugin(shapes, shapeAttrs, textAttrs) {
			return this.getView().canEditCanvas() && this.inherited(arguments);
		},

		/**
		 * Save SVG and stay in edit mode; use throttled on click to prevent double-click errors
		 */
		onClickThrottled: function() {
			this.getView().save();
		}
	});
});